import { useTranslation } from 'react-i18next';

import { Tabs } from '../../components/Tabs';
import { PageHeader } from '../../components/PageHeader';
import { RegisterPanel } from './RegisterPanel';
import { RequestsPanel } from './RequestsPanel';
import { RetentionPanel } from './RetentionPanel';
import { RetentionSettings } from './RetentionSettings';

/**
 * Die Datenschutzwerkzeuge -- F5-11 bis F5-15.
 *
 * Drei Reiter statt drei Adressen: Sie gehoeren fachlich zusammen, werden
 * selten gebraucht und selten verlinkt. Wer hier arbeitet, arbeitet an einem
 * Vorgang -- einem Ersuchen, einer Pruefung -- und wechselt dabei zwischen
 * ihnen.
 *
 * **Das Protokoll steht nicht mehr hier**, sondern nur noch auf der Seite
 * "Audit" daneben (F5-02). Zwei Ansichten desselben Protokolls waren zwei
 * Stellen, an denen man suchen musste -- und nur eine davon konnte
 * ausgeben. Die Ausgabe als Datei hat "Audit" jetzt auch.
 *
 * **Alles hier traegt ``privacy.manage``.** Der Auskunftsexport zieht alles
 * zusammen, was ueber eine Person gespeichert ist; der Aufbewahrungslauf
 * loescht. Keine dieser Faehigkeiten gehoert in die taegliche Arbeit.
 */
export function PrivacyPage() {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('privacy.title')} subtitle={t('privacy.subtitle')} />

      <Tabs
        ariaLabel={t('privacy.title')}
        tabs={[
          { value: 'requests', label: t('privacy.tabRequests'), content: <RequestsPanel /> },
          // Die Fristen ueber dem Lauf, der sie anwendet -- F5-13. Sie
          // standen in zwei Reitern ("Aufbewahrung", "Aufbewahrungsfristen"),
          // die fast gleich hiessen; wer eine Frist aendert, will danach im
          // selben Blick den Probelauf sehen.
          {
            value: 'retention',
            label: t('privacy.tabRetention'),
            content: (
              <div className="stack">
                <RetentionSettings />
                <RetentionPanel />
              </div>
            ),
          },
          { value: 'register', label: t('privacy.tabRegister'), content: <RegisterPanel /> },
        ]}
      />
    </>
  );
}
